<template>
  <b-button
    class="vp-button"
    :pill="radius ? false : true"
    :variant="isDanger ? 'outline-danger' : (isOutline ? 'outline-primary' : 'primary')"
    :style="{ width, height, 'border-radius': radius ? radius : '' }"
    @click="handleEmit"
    :disabled="disabled"
    :type="type"
  >
  <i
    v-if="isLoading"
    class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
  ></i>
    <span class="btn-text">{{ text }}</span>
  </b-button>
</template>

<script>
export default {
  name: "GlobalButton",
  props: {
    text: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      default: "112px",
    },
    height: {
      type: String,
      default: "32px",
    },
    radius: {
      type: String,
      default: "16px",
    },
    isDanger: {
      type: Boolean,
      default: false,
    },
    isOutline: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "button",
    },
    fontWeight:{
      type: String,
      default: "400"
    }
  },
  methods: {
    handleEmit(value) {
      this.$emit("click", value);
    },
  },
  beforeMount(){
    this.$nextTick(() => {
    const btn = document.querySelector('.vp-button')
    btn.style.setProperty('font-weight', this.fontWeight, 'important');
    })
  }
};
</script>

<style lang="scss">
.vp-button {
  font-size: 16px !important;
  line-height: 19.2px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
      border-radius: 16px !important;
}

.vp-button:not(.disabled) {
  cursor: pointer !important;
}

.btn-primary {
  background: #103f5e;
  color: #fff;
  border: none !important;
}

.rounded-pill {
}
</style>
